import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/racq-icon-sm.svg'
import _imports_1 from '@/assets/icons/racq-icon-lg.svg'
import _imports_2 from '@/assets/icons/menu-icon.svg'


const _hoisted_1 = {
  id: "sticky-header",
  class: "lg:hidden top-0 sticky w-full px-5 py-4 flex items-center shadow-md z-99 bg-racq-true-white z-50"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useAccountStore, usePageStore, useSelfServicePhysicalMembershipCardStore } from '@/store';
import { FormProps } from '@/interfaces';
import NavigationPanel from '../NavigationPanel/NavigationPanel.vue';
import MembershipCardModal from '@/components/MembershipCard/MembershipCardModal.vue';
import { useRoute } from 'vue-router';
import { Field } from '@sitecore-jss/sitecore-jss-vue';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'SelfServiceMenu',
  props: {
    componentDir: {},
    errorComponent: {},
    rendering: {},
    fields: {},
    params: {}
  },
  setup(__props: any) {

const route = useRoute();
const props = __props;

const physicalCardStore = useSelfServicePhysicalMembershipCardStore();
const pageStore = usePageStore();
const accountStore = useAccountStore();

const scrollAllowed = ref(true);

const menuClasses = computed(() => {
  return pageStore.menuOpened ? '' : 'translate-x-[-354px] md:translate-x-[-511px]';
});

const title = computed(() => {
  return (
    props.fields.title?.value
      ?.replace('{{firstname}}', accountStore.identityDetails?.firstName)
      .replace('{{surname}}', accountStore.identityDetails?.lastName) ?? ''
  );
});
const subtitle = computed(() => {
  return (
    props.fields.subtitle?.value?.replace('{{loyaltyLevel}}', accountStore.identityDetails?.membershipLoyalty) ?? ''
  );
});
const primaryButton = computed(() => props.fields.primaryButton?.value ?? '');
const secondaryButton = computed(() => props.fields.secondaryButton?.value ?? '');
const logoutButton = computed(() => props.fields.logoutButton?.value ?? '');

const primaryMenuItems = computed(() => props.fields.childItems?.filter((item) => item.fields.isPrimary.value) ?? []);
const secondaryMenuItems = computed(
  () => props.fields.childItems?.filter((item) => !item.fields.isPrimary.value) ?? []
);
const membershipCardModalModalEl = ref<InstanceType<typeof MembershipCardModal>>();

const membershipCardModalData = computed<Field<string | boolean | number> | any | any[]>(() => {
  return props.fields.membershipCardModal;
});

// ----------------------------------------------------------------------------------
// Life hooks
// ----------------------------------------------------------------------------------
onMounted(() => {
  physicalCardStore.membershipCardModal = props.fields.membershipCardModal;
  membershipCardDeepLinkCheck();
  // Detect resize
  resize();
  window.addEventListener('resize', resize);

  // Detect left swipe
  let touchstartX = 0;
  let touchendX = 0;

  const drawer = document.getElementById('self-service-menu-drawer') as HTMLDivElement;
  if (drawer) {
    drawer.addEventListener(
      'touchstart',
      (event) => {
        touchstartX = event.changedTouches[0].screenX;
      },
      false
    );

    drawer.addEventListener(
      'touchend',
      (event) => {
        touchendX = event.changedTouches[0].screenX;
        if (touchendX + 100 < touchstartX && window.innerWidth < 992) {
          pageStore.menuOpened = false;
          allowScroll();
        }
      },
      false
    );
  }
  pageStore.homePage = {
    name: primaryMenuItems.value[0].fields?.link?.value?.text,
    value: primaryMenuItems.value[0].fields?.link?.value?.href,
  };

  pageStore.membershipCardModalData = membershipCardModalData.value;
});

onUnmounted(() => {
  window.removeEventListener('resize', resize);
  allowScroll();
});

// ----------------------------------------------------------------------------------
// Functions
// ----------------------------------------------------------------------------------
const toggleMenu = () => {
  pageStore.toggleMenu();
  pageStore.menuOpened ? preventScroll() : allowScroll();
};

const secondaryMenuClick = () => {
  if (membershipCardModalModalEl?.value) {
    membershipCardModalModalEl?.value.showModal();
  }
};

const resize = () => {
  if (!pageStore.menuOpened && window.innerWidth >= 992) {
    pageStore.menuOpened = true;
  } else if (pageStore.menuOpened && window.innerWidth < 992) {
    pageStore.menuOpened = false;
  }
  allowScroll();
};

const preventScroll = () => {
  if (!scrollAllowed.value) return;
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = 'fixed';
  document.body.style.overflowY = 'hidden';
  document.body.style.width = '100%';
  scrollAllowed.value = false;
};

const allowScroll = () => {
  if (scrollAllowed.value) return;
  const scrollTop = parseInt(document.body.style.top || '0') * -1;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.overflowY = '';
  window.scrollTo(0, scrollTop);
  scrollAllowed.value = true;
};

const membershipCardDeepLinkCheck = () => {
  // Deep link check for modal
  if (route.query.membercard !== undefined) {
    setTimeout(() => {
      membershipCardModalModalEl.value?.showModal();
    }, 100);

    // Optional: Remove query param after showing modal
    //const { membercard, ...rest } = route.query;
    //router.replace({ query: rest });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: primaryMenuItems.value[0].fields?.link.value.href ?? '#',
        class: "lg:hidden"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: _imports_0,
          width: "48",
          height: "20",
          alt: "racq-icon",
          class: "h-[20px]"
        }, null, -1)
      ]), 8, _hoisted_2),
      _createElementVNode("a", {
        href: primaryMenuItems.value[0].fields?.link.value.href ?? '#',
        class: "hidden lg:block"
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_1,
          width: "56",
          height: "22",
          alt: "racq-icon",
          class: "h-[22px]"
        }, null, -1)
      ]), 8, _hoisted_3),
      _createElementVNode("img", {
        src: _imports_2,
        height: "24",
        width: "24",
        alt: "menu-icon",
        class: "ml-auto",
        onClick: toggleMenu
      })
    ]),
    (_unref(pageStore).menuOpened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lg:hidden backdrop w-screen absolute top-0 bottom-0 bg-black opacity-65 z-60 overflow-hidden",
          onClick: toggleMenu
        }))
      : _createCommentVNode("", true),
    _createVNode(NavigationPanel, {
      homeLink: primaryMenuItems.value[0].fields?.link,
      profileLink: props.fields.profileLink,
      menuClasses: menuClasses.value,
      title: title.value,
      subtitle: subtitle.value,
      primaryButton: primaryButton.value,
      secondaryButton: secondaryButton.value,
      logoutButton: logoutButton.value,
      primaryMenuItems: primaryMenuItems.value,
      secondaryMenuItems: secondaryMenuItems.value,
      toggleMenu: toggleMenu,
      onSecondaryClick: secondaryMenuClick
    }, null, 8, ["homeLink", "profileLink", "menuClasses", "title", "subtitle", "primaryButton", "secondaryButton", "logoutButton", "primaryMenuItems", "secondaryMenuItems"]),
    _createVNode(MembershipCardModal, {
      ref_key: "membershipCardModalModalEl",
      ref: membershipCardModalModalEl,
      membershipCardModal: membershipCardModalData.value
    }, null, 8, ["membershipCardModal"])
  ], 64))
}
}

})